import { z } from 'zod';

export const AtsName = z.enum([
  'Greenhouse',
  'Ashby',
  'Lever',
  'Teamtailor',
  'Workday',
  'iCIMS',
  'SmartRecruiters',
  'Jobvite',
  'BambooHR',
  'JazzHR',
  'Workable',
  'BreezyHR',
  'Recruitee',
  'Phenom',
  'ADP',
  'Taleo',
  'UKG',
  'SuccessFactors',
  'Dayforce',
  'Eightfold',
  'OracleHCM',
  'Paylocity',
  'Rippling',
  'Avature',
  'Paradox',
  'Lensa',
  'TheLadders',
  'Talent.com',
  'Dice',
  'ZipRecruiter',
  'Indeed',
  'MicrosoftCareers',
  'Airbnb',
  'Centene',
  'Unknown',
]);
export type AtsName = z.infer<typeof AtsName>;
